import pathosBadge from "../../static/icons/Pathos-badge.PNG";

const PathosData = {
  projectName: "Pathos | AI-powered Empathy enhancer [in progress]",
  backgroundColor: "#F7F0F9",
  description:
    "Award winning AI-powered platform aiming to boost empathy and emotional intelligence in remote workplace environments. Pathos is designed with a keen focus on improving interpersonal communications by providing real-time suggestions, ensuring clearer, more effective conversations.",
  demoVideo: "https://www.youtube.com/embed/LbjaO1Lkncc?si=OEo8Cf-yhRpqSyYA",
  github: "https://github.com/coderhimanshu1/Pathos",
  liveLink: "",
  badge: pathosBadge,
  API: "",
  role: "Frontend-focused Full-stack Developer",
  techStack: "React, Node.js, Express.js, AI Integration",
  timeline: "September, 2023 - October, 2023",
  devFlow: {
    headings: [
      {
        heading: "AI Integration >>>",
        steps: {
          step1: {
            header: "Emotion Analysis",
            text: "Incorporated AI models to analyze conversations and interpret context, translating them into identifiable emotions to provide real-time communication suggestions.",
          },
          step2: {
            header: "Real-time Data Flow",
            text: "Integrated Slack API to ensure seamless real-time communication, enabling instant feedback during conversations.",
          },
          step3: {
            header: "User Profiles and Feedback",
            text: "Designed tones for users to stay engaged and provide personalized feedback.",
          },
        },
      },
      {
        heading: "Frontend Development >>>",
        steps: {
          step1: {
            header: "Responsive UI Design",
            text: "Crafted an intuitive user interface that adapts to multiple devices, ensuring a smooth user experience across platforms.",
          },
        },
      },
    ],
  },
  keyChallenges: [
    {
      header: "Real-time AI Analysis",
      challenge:
        "Ensuring real-time and accurate data flow and analysis was a challenging task, as the AI models were designed to analyze and interpret conversations in real-time.",
      solution:
        "Optimized the AI models and used efficient algorithms to ensure quick processing and minimal latency.",
    },
  ],
  learnings: [
    {
      header: "AI in Interpersonal Communication",
      text: "Pathos gave me profound insights into the potential of AI in enhancing human interactions. The ability to analyze and provide feedback on emotional intelligence in real-time opened up possibilities for genuine, empathetic conversations.",
    },
    {
      header: "Real-time Data Handling",
      text: "Through the development of Pathos, I learned the intricacies of managing real-time data flow, ensuring that users receive instantaneous feedback without any perceivable delay.",
    },
  ],
};

export default PathosData;
